import { EntityType } from '@neptune/shared/entity-domain';
import type { Widget, WidgetDefinitionNew } from '@neptune/shared/widgets-domain';

import { AttributeDefinition } from 'domain/experiment/attribute';
import { WidgetDefinition } from 'domain/widget/core/domain/widget-definition';

import { FileSeriesWidgetOptions } from './file-series-configuration';

export const FILE_SERIES_WIDGET_DEFINITION_METADATA: WidgetDefinitionNew = {
  widgetType: 'fileSeries',
  label: 'File series',
  description: 'Visualize a file at different steps',
  icon: 'file-series',
  dataItem: 'fileSeries',
  hasSettings: true,
};

export type FileSeriesWidget = Widget & {
  type: 'fileSeries';
  options: FileSeriesWidgetOptions;
};

export function isFileSeriesWidget(widget: Widget): widget is FileSeriesWidget {
  return widget.type === 'fileSeries';
}

export type FileSeriesSource = {
  attributes: AttributeDefinition[];
  entityShortId: string;
  entityId: string;
  entityType: EntityType;
  projectIdentifier: string;
};

export function fileSeriesWidgetOptionsFromApiToDomain(
  options?: Record<string, any>,
): FileSeriesWidgetOptions {
  return {
    defaultStep: options?.defaultStep,
  };
}

export const fileSeriesWidgetDefinition: WidgetDefinition = {
  type: 'fileSeries',
  fromApiToDomain: fileSeriesWidgetOptionsFromApiToDomain,
};
